export {
    generateMarkerColorPalette,
    getColorFromPalette,
    getMarkerColor,
    getRandomMarkerColor,
    MARKER_COLOR_PALETTE
} from './map/colors';

export {
    logCurrentBounds,
    getPOIIcon,
    getPOISymbol,
    getPOICategoryId,
    getPOIColorToken,
    getPOIColorCssValue,
    calculateDistance
} from './map/utils';

export { mockAsyncCall } from './mock/utils';

export {
    convertAppTenantSnapToAppTenant,
    convertGeoPointToPosition,
    convertPositionToGeoPoint,
    removeUndefinedFields,
    extractPoint,
    ensureMillis
} from './mapper/firestore-mapper';

export const isLocalHost = () => {
    const t1 = ['localhost', '127.0.0.1'].includes(window.location.hostname);
    const t2 = window.location.hostname.startsWith('192.168');
    return t1 || t2;
}

export { cleanMacAddress, formatMacAddress } from './macAddress';